import { isRichTextValueConsideredEmpty } from "@uniformdev/richtext";

import {
    ArticleCta,
    ArticleCtaProps
} from "@/libraries/design/components/article-cta/src/article-cta";
import { RichTextComponent } from "@/libraries/design/utils";

export interface UniformArticleCtaProps extends ArticleCtaProps {
    uniformRichText?: unknown;
    richText?: string; // for rich text from Contentful
}

const UniformArticleCta = (props: UniformArticleCtaProps) => {
    const articleCtaProps = {
        ...props,
        copy: props.richText ? (
            <RichTextComponent text={props.richText} />
        ) : !isRichTextValueConsideredEmpty(props.uniformRichText) ? (
            <RichTextComponent uniformParameter="uniformRichText" />
        ) : (
            props.copy
        )
    };
    return (
        <ArticleCta
            {...articleCtaProps}
            dataEventProps={{
                "data-product-key": "uniform",
                "data-event-component": "linkButton",
                "data-event-container": "ctaSection",
                "data-event": "clicked"
            }}
        />
    );
};

export default UniformArticleCta;
